module.exports = __webpack_public_path__ + "assets/img/dzh-38.b7083044.jpg";